export const sortOrder = {
  ASCEND: 'ascend',
  DESCEND: 'descend'
} as const

export const TABLE_COLUMN_SORT_BASE_CLASS_NAME = 'table-column-sort'
